module.exports = __webpack_public_path__ + "media/18.da6d97d1.mp3";